export default class CoordGeoFormController {
	/* @ngInject */
	constructor(ApiGeoService, $scope, $timeout) {
		this.ApiGeoService = ApiGeoService;
		this.$scope = $scope;
		this.unregister = [];
		this.$timeout = $timeout;
	}
	async $onInit() {
		this.checkCoordGeo();

		if (this.autoUpdateMap) {
			// On watch tout changement sur les CoordGéo du lieu
			this.unregister.push(
				this.$scope.$watch(
					() => this.coordGeo,
					() => {
						this.reloadPosition();
					},
					true
				),
				this.$scope.$watch(
					() => this.adresse,
					() => {
						this.reloadPosition();
					},
					true
				),
				this.$scope.$watch('$ctrl.isOpen', (value) => {
					if (value) {
						this.$timeout(() => {
							this.updateMapCamera();
						}, 500);
					}
				})
			);
		}
	}

	reloadPosition() {
		if (this.coordGeo && this.coordGeo.longitude && this.coordGeo.latitude) {
			this.updateMapCamera();
		} else {
			this.loadGeoFromAddress();
		}
	}

	onMapClick = async (event) => {
		if (this.isReadOnly || this.isDisabled) return;
		await this.setCoordGeoByPoint(event.latlng);
		await this.setCoordGeoCadastreByPoint(event.latlng);
	};

	setMapController(controller) {
		this.mapController = controller;
		this.$timeout(() => {
			this.updateMapCamera();
		}, 700);
	}

	async setCoordGeoByPoint(point) {
		const geo = await this.ApiGeoService.getGeoByCoord(point.lng, point.lat);
		if (geo.features.length > 0) {
			const lieu = geo.features[0].properties;
			this.coordGeo.adresse = lieu.name;
			this.coordGeo.codePostal = lieu.postcode;
			this.coordGeo.ville = lieu.city;
			if (this.paysList && this.paysList.items) {
				const pays = this.paysList.items.find((p) => p.libelle && p.libelle.includes('FR'));
				if (pays) {
					this.coordGeo.idPays = pays.Id;
				}
			}
		} else {
			this.clearCoordGeo();
		}
	}

	myToggleOpen() {
		this.$timeout(() => {
			this.updateMapCamera();
		}, 300);
	}

	updateMapCamera() {
		this.$timeout(() => {
			if (this.mapController && this.coordGeo && this.coordGeo.latitude && this.coordGeo.longitude) {
				this.mapController.updateMarker(this.coordGeo.latitude, this.coordGeo.longitude);
				this.mapController.updateCamera(this.coordGeo.latitude, this.coordGeo.longitude, 18);
			}
		}, 200);
	}

	async loadGeoFromAddress() {
		this.loadingFromAdress = true;
		await this.loadMapCoordinatesFromAddress();
		this.loadingFromAdress = false;
	}

	async loadMapCoordinatesFromAddress() {
		let point = null;
		if (this.adresse && this.codePostal && this.ville) {
			this.fullAdresse = `${this.adresse} ${this.codePostal} ${this.ville}`;
			const geo = await this.ApiGeoService.getGeoByAdresse(this.fullAdresse);
			if (geo && geo.features.length > 0) {
				point = {
					lat: geo.features[0].geometry.coordinates[1],
					lng: geo.features[0].geometry.coordinates[0]
				};
				await this.setCoordGeoCadastreByPoint(point);
				this.mapController.updateMarker(point.lat, point.lng);
				this.mapController.updateCamera(point.lat, point.lng, 18);
			} else {
				this.clearCoordGeo();
			}
		}
		return point;
	}

	async setCoordGeoCadastreByPoint(point) {
		let cadastre = await this.ApiGeoService.getCadastreByCoord(point.lng, point.lat);
		this.checkCoordGeo();
		if (cadastre && cadastre.features.length > 0) {
			this.coordGeo.numParcelle = Number(cadastre.features[0].properties.numero);
			this.coordGeo.feuilleCadastrale = cadastre.features[0].properties.feuille;
			this.coordGeo.sectionCadastrale = cadastre.features[0].properties.section;
			this.coordGeo.contenance = cadastre.features[0].properties.contenance;
			this.coordGeo.codeInsee = cadastre.features[0].properties.code_insee;
		} else {
			this.clearCoordGeo();
		}
		this.coordGeo.longitude = point.lng;
		this.coordGeo.latitude = point.lat;
	}

	checkCoordGeo() {
		if (this.coordGeo == null || this.coordGeo == undefined) {
			this.clearCoordGeo();
		}
	}

	clearCoordGeo() {
		this.coordGeo = {
			longitude: null,
			latitude: null,
			numParcelle: null,
			feuilleCadastrale: null,
			sectionCadastrale: null,
			contenance: null,
			codeInsee: null
		};
	}

	onCoordInputChanged() {
		if (!this.mapController) return;

		const lat = parseFloat(this.coordGeo.latitude);
		const lng = parseFloat(this.coordGeo.longitude);

		if (isNaN(lat) || isNaN(lng)) return;

		this.mapController.updateMarker(lat, lng);
		this.mapController.updateCamera(lat, lng, 18);
	}
}
